import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { PortalModule } from '@angular/cdk/portal';

import { PillarModule } from '../pillar/pillar.module';
import { administrationRoutes } from './routes.config';
import { AdministrationDashboardComponent } from './components/administration-dashboard.component';

@NgModule({
  entryComponents: [],
  declarations: [AdministrationDashboardComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule.forChild(administrationRoutes),
    PortalModule,
    PillarModule
  ],
  exports: [],
  providers: []
})
export class AdministrationModule {
}



// WEBPACK FOOTER //
// ./src/app/administration/administration.module.ts